import { useTranslation } from 'react-i18next'
import React, { useEffect, useState } from 'react'
import { useStore } from '../../../StateProvider'
import { equals, map } from 'ramda'
import { Select } from '../../../ui'
import { fetchFeePeriod } from '../../api'

const ExternalFeePeriodSelect = ({ label, name, additionalInfo }) => {
  const { t, i18n } = useTranslation()
  const [value, setValue] = useState('')
  const [list, setList] = useState([])
  const [isValid, setIsValid] = useState(null)
  const [, dispatch] = useStore()

  useEffect(() => {
    /**
     * @param {OptionsInput} data
     */
    const fetchCallback = (data) => {
      const list = data.map((item) => ({ label: t(`createPammFund.${item}`), value: item }))
      setList(list)
    }
    fetchFeePeriod().then(fetchCallback)
  }, [i18n.language, name])

  /**
   * @param {string} value
   */
  const getSelectValue = (value) => (equals(value, t('generatedField.choose')) ? '' : value)

  /**
   * @param {{target: {value: string, name: string}}} props
   */
  const onChange = ({ target: { value, name } }) => {
    const selectedValue = getSelectValue(value)
    setValue(selectedValue)
    setIsValid(selectedValue.length > 0)
    dispatch({
      type: 'setExtFieldValue',
      name,
      value: selectedValue
    })
    dispatch({ type: 'setValidationFld', name, value: selectedValue.length > 0 })
  }

  return (
    <Select
      value={value || ''}
      label={t(label)}
      placeholder={t('generatedField.choose')}
      options={list}
      onChange={onChange}
      name={name}
      key={name}
      error=''
      valid={isValid}
      info={additionalInfo ? t(`generatedField.${name}AdditionalInfo`) : ''}
    />
  )
}

const getExternalFeePeriodSelectFields = map(currencyField => {
  const { i18n, name, required, order, dependOnBooleanFldName } = currencyField
  return (
    <ExternalFeePeriodSelect
      label={i18n ? `generatedField.${i18n}` : ''}
      name={name}
      required={required}
      key={name}
      order={order}
      dependOnBooleanFldName={dependOnBooleanFldName}
    />
  )
})

export { ExternalFeePeriodSelect, getExternalFeePeriodSelectFields }
